import * as React from "react";
import { flushSync } from "react-dom";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useState } from "react";
import { useEffect } from "react";
import styles from "./DocumentList.module.scss";
import { Button } from "@progress/kendo-react-buttons";
import {
  addClientDocumentItem,
  addContactDocumentItem,
  addSupplierDocumentItem,
  getDocument,
  updateContactDocumentItem,
  updateClientDocumentItem,
  updateSupplierDocumentItem,
} from "api/index";
import {
  validateDate,
  validateDetails,
  validateNotes,
} from "../BatchPosting/InputComponents";
import { CONSTANT } from "CONSTANT/Matter/MatterForm";
import MatterModal from "components/Matters/MatterModal";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { toast } from "react-toastify";
import { Loader } from "@progress/kendo-react-indicators";
import { useUploadForm } from "components/fileUploadHook";
import { FileDocumentTypes } from "components/Enums/FileDocumentTypes.ts";
import { onFileUpload } from "services/fileDataService";
import { RiUpload2Fill } from "react-icons/ri";
import DocumentViewer from "components/common/DocumentViewer";
import { Tile } from "components/UIComponents/Tile";
import { FileDragDrop } from "pages/CaseFile/CaseActivities/CaseActivitiesPage";
import SubmitButton from "components/common/SubmitButton";
import { formatDateForAPI } from "components/common/formatter";


const supplierRegisterId = (doc) =>
  doc?.supplierDocumentID ?? doc?.clientDocumentID ?? doc?.id;

const ClientDocumentModal = ({ canModify, component, ...props }) => {
  const isSupplier = props.supplierId != null;
  const isContact = component === "contact";
  const [isView] = useState(props.docId ? true : false);
  const [filesData, setFilesData] = useState([]);
  const { uploadForm } = useUploadForm();

  const [initialData, setInitialData] = useState({
    date: new Date(),
  });
  const filePickerRef = React.useRef();
  const uploadRef = React.createRef();
  const [isLoading, setIsLoading] = useState(props.docId ? true : false);
  const [isFileLoading, setIsFileLoading] = useState(false);
  const [details, setDetails] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalSuccess, setModalSuccess] = useState(undefined);
  const [newMaterId, setNewMatterId] = useState({
    matterId: props?.matterId?.matterId,
    matterRef: props?.matterId?.matterRef,
    matterDetails: props?.matterId?.matterDetails,
  });
  const [inputState, setInputState] = useState({
    annualFee: null,
  });
  const [validationAttempted, setValidationAttempted] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const handleUpload = async (e) => {
    try {
      setIsFileLoading(true);
      let data = onFileUpload(e);
      const parameters = isSupplier
        ? {
          documentType: FileDocumentTypes.SupplierDocs,
          moduleId: props.supplierId,
          supplierRef: props.supplierRef,
          moduleRef: props.supplierRef,
        }
        : isContact
          ? {
            documentType: FileDocumentTypes.ContactDocs,
            contactId: props.contactId,
          }
          : {
            documentType: FileDocumentTypes.ClientDocs,
            clientId: props?.clientId?.clientId,
          };
      const dataChoosen = await uploadForm(data, e.target.files[0], parameters);
      data.fileID = dataChoosen.data.data.fileID;
      setFilesData([
        {
          ...dataChoosen?.data?.data,
        },
      ]);
    } catch (error) {
    } finally {
      setIsFileLoading(false);
    }
  };

  const handleDrop = (event) => {
    if (!props.docId?.documentId) {
      handleUpload({
        target: {
          files: [...event],
        },
      });
    }
  };

  React.useEffect(() => {
    if (props.droppedFiles?.length) {
      handleUpload({
        target: {
          files: props.droppedFiles,
        },
      });
    }
  }, [props.droppedFiles]);

  const getDocuemntData = async (id) => {
    try {
      if (id) {
        const { data } = await getDocument(id);
        setFilesData([data?.data?.documentFile]);
      }
    } catch (error) { }
  };

  const handleFormSubmit = async (values, e) => {
    e.preventDefault();
    setIsSaving(true);
    if (props.docId) {
      const dataObject = {
        ...values,
        date: values?.date ? formatDateForAPI(values.date) : values?.date,
        feeEarnerRef: values?.feeEarnerRef?.userRef || values?.feeEarnerRef,
      };
      try {
        if (isSupplier) {
          const regId = supplierRegisterId(props.docId);
          if (!regId) return;
          const res = await updateSupplierDocumentItem(
            { data: dataObject },
            props.supplierId,
            regId
          );
          if (res?.status === 200) {
            props.updateData();
            toast.success("Document register updated");
          }
        } else if (isContact) {
          const regId =
            props.docId?.contactDocumentID ??
            props.docId?.contactDocumentId ??
            props.docId?.id;
          if (!regId) return;
          const res = await updateContactDocumentItem(
            { data: dataObject },
            props.contactId,
            regId
          );
          if (res?.status === 200) {
            props.updateData();
            toast.success("Document register updated");
          }
        } else {
          const res = await updateClientDocumentItem(
            {
              data: dataObject,
            },
            props.clientId?.clientId,
            props.docId?.clientDocumentID
          );
          if (res?.status === 200) {
            props.updateData();
            toast.success("Doocument Register Updated");
          }
        }
        return;
      } catch (err) { } finally {
        setValidationAttempted(false);
        setIsSaving(false);
      }
    } else {
      const dataObject = {
        ...values,
        date: values?.date ? formatDateForAPI(values.date) : values?.date,
        fileId: filesData[0]?.fileID,
        feeEarnerRef: values?.feeEarnerRef?.userRef,
      };
      try {
        if (isSupplier) {
          const res = await addSupplierDocumentItem(
            { data: dataObject },
            props.supplierId
          );
          if (res?.status === 200) {
            props.updateData();
            toast.success("Document register added");
          }
        } else if (isContact) {
          const res = await addContactDocumentItem(
            { data: dataObject },
            props.contactId
          );
          if (res?.status === 200) {
            props.updateData();
            toast.success("Document register added");
          }
        } else {
          const res = await addClientDocumentItem(
            { data: dataObject },
            props.clientId.clientId
          );
          if (res?.status === 200) {
            props.updateData();
            toast.success("Document Regsiter added");
          }
        }
      } catch (err) {
        console.log(err);
      } finally {
        setValidationAttempted(false);
      }
    }
    setIsSaving(false);
  };

  const requiredValidator = (value) => (value ? "" : "This field is required.");

  const handleModalClose = () => {
    setShowModal(false);
    if (modalSuccess) {
      const myObj = {
        dataItem: {
          matterId: newMaterId,
          matterRef: inputState[CONSTANT.INPUT.MATTER_REF],
          matterDetails: details,
        },
      };
      props.setshowMatterForm();
      if (!props.isView) {
        props.onMatterRefClickActions(myObj);
      }
    }
  };

  const initialLoad = React.useCallback(async () => {
    if (!props.docId) return;
    try {
      setInitialData({
        ...props.docId,
        date: new Date(props.docId?.date),
      });
      await getDocuemntData(props.docId?.documentId);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, [props.docId]);

  useEffect(() => {
    if (!props.docId) return;
    initialLoad();
  }, [props.docId, initialLoad]);

  return (
    <div>
      <Dialog
        className={`dialog-md ${styles["view-document-dialog"]}`}
        title={
          isView
            ? "View Document"
            : props.docId
              ? "Edit Document"
              : "Add Document"
        }
        onClose={props.setshowMatterForm}
      >
        <div style={{ overflow: "hidden" }}>
          {isLoading ? (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ minHeight: "500px" }}
            >
              <Loader themeColor={"warning"} size={"large"} type={"pulsing"} />
            </div>
          ) : (
            <>
              <div className="row">
                <div
                  className="col-4"
                  style={{
                    width: "380px",
                  }}
                >
                  <div
                    className="p-3 pt-4 ps-5 pe-4 overflow-auto d-flex justify-content-center bgForm "
                    style={{
                      height: "560px",
                    }}
                  >
                    <Form
                      ignoreModified={true}
                      onSubmit={handleFormSubmit}
                      initialValues={initialData}
                      key={JSON.stringify(initialData)}
                      render={(formRenderProps) => {
                        return (
                          <div>
                            <FormElement noValidate>
                              <fieldset>
                                {formRenderProps.visited &&
                                  formRenderProps.errors &&
                                  formRenderProps.errors
                                    .VALIDATION_SUMMARY && (
                                    <div
                                      className={
                                        "k-messagebox k-messagebox-error"
                                      }
                                    >
                                      {
                                        formRenderProps.errors
                                          .VALIDATION_SUMMARY
                                      }
                                    </div>
                                  )}

                                <div className="d-flex mb-3  note-date-picker">
                                  <div
                                    style={{
                                      // width: "150px",
                                      marginRight: "15px",
                                    }}
                                  >
                                    <Field
                                      name="date"
                                      component={validateDate}
                                      validator={requiredValidator}
                                    />
                                  </div>
                                </div>

                                <div className="mb-3">
                                  <Field
                                    validator={requiredValidator}
                                    name="details"
                                    component={validateDetails}
                                    width={"260px"}
                                    validationAttempted={
                                      validationAttempted
                                    }
                                  />
                                </div>

                                <div className="mb-3">
                                  <Field
                                    name="notes"
                                    component={validateNotes}
                                    style={{
                                      width: "260px",
                                    }}
                                    validationAttempted={
                                      validationAttempted
                                    }
                                  />
                                </div>

                                <button
                                  type="submit"
                                  className="d-none"
                                  id="submit"
                                // onClick={() => {
                                //   formRenderProps.onFormReset();
                                // }}
                                >
                                  clc
                                </button>
                              </fieldset>
                            </FormElement>
                          </div>
                        );
                      }}
                    />
                  </div>
                </div>
                <div className="col-7 mt-3 ms-1">
                  <FileDragDrop
                    onFilesDrop={handleDrop}
                    uploadRef={uploadRef}
                  >
                    <Tile
                      heading="Document"
                      height={"520px"}
                      className="ps-3 pe-3"
                    >
                      <div
                        style={{
                          height: "calc(100% - 70px)",
                          overflowY: "auto",
                          overflowX: "hidden",
                        }}
                      >
                        {filesData[0] ? (
                          <DocumentViewer
                            data={filesData}
                            onScreenComponent={true}
                            iconLess={true}
                          />
                        ) : (
                          <div
                            onClick={(e) => filePickerRef?.current?.click()}
                            className={`d-flex align-items-center cursor-pointer justify-content-center`}
                            style={{
                              height: "80%",
                            }}
                          >
                            {isFileLoading ? (
                              <div>
                                <div
                                  className="spinner-border spinner"
                                  role="status"
                                // style={{ marginRight: "60px" }}
                                ></div>
                              </div>
                            ) : (
                              <>
                                <div className="mt-3">
                                  <p className={styles["doc-upload-text"]}>
                                    {filesData[0]?.downloadURL
                                      ? "Update"
                                      : "Attach"}
                                    <br /> Documents
                                  </p>
                                </div>
                                <div className={styles["vertical-rule"]}></div>
                                <div
                                  className={`${styles["file-upload-icon"]} d-flex align-items-center justify-content-center position-relative`}
                                >
                                  <RiUpload2Fill color="#DCDAFF" size={20} />
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </Tile>
                  </FileDragDrop>
                </div>
              </div>
              <button
                id="doc-reg"
                style={{
                  visibility: "hidden",
                }}
                type="submit"
              ></button>
            </>
          )}
        </div>

        <input
          name="file"
          type="file"
          onChange={handleUpload}
          ref={filePickerRef}
          style={{
            visibility: "hidden",
          }}
        />
        <DialogActionsBar>
          <div className="dialog-footer">
            <Button
              className="common-btn bgBtnSecondary border-0 me-3"
              onClick={props.setshowMatterForm}
            >
              Cancel
            </Button>
            <SubmitButton
              className="me-4"
              type="button"
              form="matterForm"
              disabled={component === "supplier" ? false : !canModify}
              isLoading={isSaving}
              onClick={(e) => {
                flushSync(() => setValidationAttempted(true));
                document.getElementById("submit").click();
              }}
            >
              Save
            </SubmitButton>
          </div>
        </DialogActionsBar>
      </Dialog >
      <MatterModal
        showModal={showModal}
        message={modalMessage}
        success={modalSuccess}
        onClose={handleModalClose}
      />
    </div >
  );
};

export default ClientDocumentModal;
